import React, { useState, useEffect } from 'react'
import { examService } from '../../_services/exam.service'
import examStatuses from '../../_constants/examStatuses'
import moment from 'moment-jalaali'
import MemberExamDetails from './MemberExamDetails'

function formatDate(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD HH:mm')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}

function formatTime(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[1], 'HH:mm')
    if (momentValue.isValid()) {
      return momentValue.format('HH:mm')
    }
  }
}

export default function MemberExams(props) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [examDetailsModalShow, setExamDetailsModalShow] = useState(false)
  const [examId, setExamId] = useState('')

  useEffect(() => {
    if (props.id) {
      getData(props.id)
    }
  }, [props.id])

  const getData = id => {
    setLoading(true)
    examService
      .getMemberExams(id)
      .then(res => {
        // console.log(res.data);
        setData(res.data)
        setLoading(false)
      })
      .catch(err => {
        // console.log(err)
        setLoading(false)
      })
  }

  const handleExamDetailsModalShow = examId_ => {
    // console.log(examId_);

    setExamId(examId_)

    setExamDetailsModalShow(true)
  }

  return (
    <React.Fragment>
      <table className="table table-striped table-hover exam-table text-center table-bordered table-canvas">
        <thead>
          <tr>
            <th>#</th>
            <th>تاریخ</th>
            <th>ساعت شروع</th>
            <th>وضعیت</th>
            <th>مشاهده جزئیات</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={'exam-' + item.id + '-' + index}>
                <td>{index + 1}</td>
                <td>{formatDate(item.createDateTime)}</td>
                <td>{formatTime(item.createDateTime)}</td>
                <td>
                  <div className="exam-result-col">
                    <span>
                      {examStatuses.filter(
                        el => el.value === item.examStatus
                      )[0] &&
                        examStatuses.filter(
                          el => el.value === item.examStatus
                        )[0].name}
                    </span>
                    {item.result && item.result.length > 0 ? (
                      <div className="currect-questions">
                        <span>
                          جواب صحیح: {item.result[0] && item.result[0].corrects}
                        </span>
                        <span>
                          جواب غلط:{' '}
                          {item.result[0] && item.result[0].incorrects}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </td>
                <td>
                  <a
                    className="btn btn-info btn-icon-rught"
                    onClick={() => handleExamDetailsModalShow(item.id)}>
                    مشاهده جزئیات
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center pb-30 pt-30 td-white">
                موردی برای نمایش وجود ندارد
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <MemberExamDetails
        examId={examId}
        show={examDetailsModalShow}
        onClose={() => setExamDetailsModalShow(false)}
      />
    </React.Fragment>
  )
}
